import { render, staticRenderFns } from "./ThirdPartyAdminActionsModal.vue?vue&type=template&id=81364dbc&"
import script from "./ThirdPartyAdminActionsModal.vue?vue&type=script&lang=ts&"
export * from "./ThirdPartyAdminActionsModal.vue?vue&type=script&lang=ts&"
import style0 from "./ThirdPartyAdminActionsModal.vue?vue&type=style&index=0&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports